<script>
import Components from './mixins/Components.js'

export default {
  mixins: [Components]
}
</script>

<style src="./sass/main.scss" lang="scss"/>



// WEBPACK FOOTER //
// src/App.vue